import PropTypes from 'prop-types'
import { Children } from 'react'
import Fade from 'react-reveal/Fade'

import { Child, Main, Root } from './Slice.style'

const Slice = ({ align = 'left', valign = 'bottom', bg, children, ...props }) => {
  const childrenCount = Children.count(children)

  return (
    <div {...props}>
      <Fade duration={1500}>
        <Root $bg={bg}>
          <Main $align={align} $valign={valign} $columns={childrenCount}>
            {Children.map(children, (child, index) => (
              <Child key={index}>{child}</Child>
            ))}
          </Main>
        </Root>
      </Fade>
    </div>
  )
}

Slice.propTypes = {
  align: PropTypes.oneOf(['center', 'left', 'right']),
  valign: PropTypes.oneOf(['top', 'center', 'bottom']),
  bg: PropTypes.string,
  children: PropTypes.node,
}

export default Slice
